// extracted by mini-css-extract-plugin
export var changeIcon = "_6r-4";
export var container = "_6r-0";
export var divider = "_6r-7";
export var externalLinkIcon = "_6r-1";
export var green = "_6r-5";
export var helpCircleIcon = "_6r-3";
export var iconButton = "_6r-2";
export var red = "_6r-6";